import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SelectOption } from '@xmedical/core';
import { XmedicalUiModule } from '@xmedical/ui';

// Pure dialog content — collects form values for a new doctor and returns
// them via dialogRef.close(). The opener (PatientDoctorsFieldsetComponent)
// runs the persist via its [doctorAddPersist] callback input.
@Component({
  selector: 'xcs-doctor-add-card',
  templateUrl: './doctor-add-card.component.html',
  styleUrls: ['./doctor-add-card.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    XmedicalUiModule,
  ],
})
export class DoctorAddCardComponent implements OnInit {

  private dialogRef = inject<MatDialogRef<DoctorAddCardComponent>>(MatDialogRef);
  private formBuilder = inject(UntypedFormBuilder);

  validate = false;
  form: UntypedFormGroup | null = null;

  contactMethodOptions: SelectOption[] = [
    { value: 'Phone', text: 'Phone' },
    { value: 'Email', text: 'Email' },
    { value: 'Fax', text: 'Fax' },
  ];

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      practiceNumber: [''],
      tel: [''],
      fax: [''],
      email: [''],
      preferredGreeting: [''],
      preferredContactMethod: [''],
    });
  }

  save(): void {
    if (!this.form) return;
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
      return;
    }
    this.validate = true;
  }

  close(): void {
    this.dialogRef.close();
  }
}
